import { render, staticRenderFns } from "./IconSend.vue?vue&type=template&id=2c4a7382&scoped=true"
import script from "./IconSend.vue?vue&type=script&lang=js"
export * from "./IconSend.vue?vue&type=script&lang=js"
import style0 from "./IconSend.vue?vue&type=style&index=0&id=2c4a7382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a7382",
  null
  
)

export default component.exports